import { ComponentType } from '@angular/cdk/overlay';
import { inject, Injectable } from '@angular/core';

import { DialogService } from '@hglobal/fin-ui';

@Injectable({
  providedIn: 'root',
})
export class SigninDialog {
  readonly #dialog = inject(DialogService);

  open<T, V>(component: ComponentType<T>, config?: V): void {
    this.#dialog.open(component, config, {
      overlayBackdropClass: 'fu-overlay-backdrop_transparent',
    });
  }
}
